import { hasActiveSignRequest } from '../hasActiveSignRequest';
export const isSentForSigning = (document) => {
    if (!document) {
        return false;
    }
    return hasActiveSignRequest(document);
};
